import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

interface ScrollArrowButtonProps {
  direction: 'left' | 'right';
  onClick: () => void;
  disabled: boolean;
  visible: boolean;
  ariaLabel: string;
  topPosition?: number | null;
}

export const ScrollArrowButton: React.FC<ScrollArrowButtonProps> = ({
  direction,
  onClick,
  disabled,
  visible,
  ariaLabel,
  topPosition,
}) => {
  if (!visible) return null;

  // If topPosition is null (container off-screen), don't render
  if (topPosition === null) return null;

  const Icon = direction === 'left' ? ChevronLeft : ChevronRight;
  const positionClass = direction === 'left' ? 'left-1' : 'right-1';

  // Use dynamic positioning if provided, otherwise fall back to Tailwind class
  const shouldUseDynamicPosition = topPosition !== undefined;
  const verticalPositionClass = shouldUseDynamicPosition ? '' : 'top-1/2 -translate-y-1/2';
  const dynamicStyle = shouldUseDynamicPosition && topPosition !== null
    ? { top: `${topPosition}px`, transform: 'translateY(-50%)' }
    : undefined;

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      aria-label={ariaLabel}
      style={dynamicStyle}
      className={`
        absolute ${positionClass} ${verticalPositionClass}
        w-9 h-9 rounded-full
        bg-black/80 border border-neutral-600
        text-white
        flex items-center justify-center
        z-10
        shadow-lg
        transition-opacity duration-200
        hover:bg-black/90
        disabled:opacity-30 disabled:cursor-not-allowed
        focus:outline-none focus:ring-2 focus:ring-purple-400 focus:ring-offset-2 focus:ring-offset-neutral-900
      `}
    >
      <Icon className="w-5 h-5" />
    </button>
  );
};
